import React from 'react'

import { authRoutes, otherPublicRoutes, marketingPublicRoutes } from './authRoutes'
import { orbitRoutes } from './orbitRoutes'
import { dashboardRoutes } from './dashboardRoutes'
import { flattenRoutes, type RoutesProps } from './utils'

export type { RoutesProps } from './utils'

const authProtectedRoutes = [dashboardRoutes, ...orbitRoutes]
const publicRoutes = [...marketingPublicRoutes, ...authRoutes, ...otherPublicRoutes]

const authProtectedFlattenRoutes = flattenRoutes([...authProtectedRoutes])
const publicProtectedFlattenRoutes = flattenRoutes([...publicRoutes])
export { publicRoutes, authProtectedRoutes, authProtectedFlattenRoutes, publicProtectedFlattenRoutes }
